import { GridFilterInputMultipleValueProps } from '@mui/x-data-grid-premium'
import { isEmpty } from 'lodash'
import { useMemo } from 'react'
import { Dropdown } from '~/@/components/inputs/selection/dropdown'
import { normalizeOption, Option } from '~/@/components/inputs/selection/utils'

export interface CustomMultiSelectFilterInputProps extends Omit<
  GridFilterInputMultipleValueProps,
  'freeSolo'
> {
  options: string[] | Option[]
  type?: 'text' | 'number'
  disabled: boolean
}

/**
 * Wrapper component for multi-select filtering with two modes:
 * 1. FreeSolo: Allows custom input values
 * 2. Regular: Only allows selection from predefined options
 */
export function CustomMultiSelectFilterInput(props: CustomMultiSelectFilterInputProps) {
  const { item, applyValue, options, type } = props

  const value = useMemo(() => {
    if (Array.isArray(item.value)) {
      return item.value
    }
    if (typeof item.value === 'string' && !isEmpty(item.value)) {
      return [item.value]
    }
    return []
  }, [item.value])

  return (
    <Dropdown
      creatable={options.length === 0}
      disabled={props.disabled}
      horizontalScroll={true}
      isMultiSelect
      onChange={(selectedValues) => {
        applyValue({ ...item, value: selectedValues })
      }}
      options={options.map(normalizeOption)}
      type={type}
      values={value}
      wrapperClassName="p-0"
    />
  )
}
